import { type ComponentProps } from 'react';
import { Root, Indicator } from '@radix-ui/react-progress';

import { cn } from '@/util/utils';

/**
 * ui-progress, READ 124:1169: 8px tall, rounded-full, the track is primary under an 80% white
 * veil (primary at 20%) and the fill is primary. Pass no value for the indeterminate state,
 * where a 40% fill slides across the track.
 */
function Progress({ className, max = 100, value, ref, ...props }: ComponentProps<typeof Root>) {
    const indeterminate = value === undefined || value === null;
    const percent = indeterminate ? 40 : Math.max(0, Math.min(100, (value / max) * 100));
    return (
        <Root
            data-slot="progress"
            max={max}
            value={indeterminate ? null : value}
            ref={ref}
            className={cn(
                'bg-primary/20 relative h-2 w-full overflow-hidden rounded-full',
                className,
            )}
            {...props}
        >
            <Indicator
                data-slot="progress-indicator"
                className={cn(
                    // Square ends, clipped round by the track (content.css .ui-progress__fill).
                    'bg-primary absolute inset-y-0 left-0 transition-[width] duration-(--duration-base) ease-(--ease-standard)',
                    indeterminate && 'animate-progress-slide',
                )}
                style={{ width: `${percent}%` }}
            />
        </Root>
    );
}

export { Progress };
